import { useState, useEffect } from "react";
// material
import { Box, Card, Container, Typography } from "@mui/material";
// components
import Scrollbar from "../table/Scrollbar";
import ListToolbar from "../table/ListToolbar";
import TableView from "../Table";
import {
  parseCurrency,
  parseDateTime,
  getMonday,
  formatDateFilter,
} from "../../utils/tableFunctions";
import {
  getSettlementFilterParams,
  getSettlementList,
  getSettlementCSV,
} from "../../services/settlements";
import moment from "moment";
import { Log, getNextPage } from "../../services/services";

import {
  DateRangeType,
  InputType,
  MinMaxType,
  MultiCheckboxesType,
  MultiSelect,
} from "../table/Filter";
import HeaderHelpPage from "../HeaderHelpPage";
import CircularLoader from "../circularLoader";

// ----------------------------------------------------------------------

export default function RejectedList() {
  const [rejected, setRejected] = useState();
  const [next, setNext] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [tableData, setTableData] = useState();
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState();
  const [fParams, setFParams] = useState({});

  // ------------------ filterStuffies --------------------//
  const [fMerchantName, setFMerchantName] = useState([]);
  const [fTerminal, setFTerminal] = useState("");
  const [fSettlement, setFSettlement] = useState("");
  const [fMethod, setFMethod] = useState([]);
  const [fDate, setFDate] = useState([getMonday(), moment()]);
  const [fBrand, setFBrand] = useState([]);
  const [fCurrency, setFCurrency] = useState([]);
  const [fNet, setfNet] = useState([]);
  const [reset, setReset] = useState(false);
  const filter = {
    settlement_id: fSettlement,
    merchant_name_list: fMerchantName,
    start_datetime: formatDateFilter(fDate[0], "start"),
    end_datetime: formatDateFilter(fDate[1], "end"),
    payment_brand_list: fBrand,
    currency: fCurrency,
    transaction_currency_list: "",
    net_amount_min: fNet[0],
    net_amount_max: fNet[1],
  };

  const filterComponents = () => {
    return (
      fParams &&
      Object.keys(fParams).length > 1 && (
        <Container sx={{ overflowX: "auto" }}>
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Settlement ID
            </Typography>
            <InputType
              value={fSettlement}
              setFInput={setFSettlement}
              reset={reset}
            />
            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Terminal ID
            </Typography>
            <InputType
              value={fTerminal}
              setFInput={setFTerminal}
              reset={reset}
            />
            <Box sx={{ height: 15 }} />
            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Merchant Name
            </Typography>
            <MultiSelect
              options={fParams.merchant_name.map((name) => ({
                value: name ? name : "",
                label: name ? name : "",
              }))}
              setSelectedValues={setFMerchantName}
              selectedValues={fMerchantName}
              reset={reset}
            />
            <Box sx={{ height: 15 }} />

            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Date
            </Typography>
            <DateRangeType date={fDate} setDate={setFDate} reset={reset} />
            <Box sx={{ height: 15 }} />

            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Payment Brand
            </Typography>
            <MultiCheckboxesType
              items={fParams.payment_brand}
              checkedValues={fBrand}
              setCheckedValues={setFBrand}
              reset={reset}
            />
            <Box sx={{ height: 15 }} />

            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Base Currency
            </Typography>
            <MultiCheckboxesType
              items={fParams.currency}
              checkedValues={fCurrency}
              setCheckedValues={setFCurrency}
              reset={reset}
            />
            <Box sx={{ height: 15 }} />

            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Net Amount
            </Typography>
            <MinMaxType
              minVal={fParams.net_amount_min}
              maxVal={fParams.net_amount_max}
              setValue={setfNet}
              value={fNet}
              reset={reset}
            />
            <Box sx={{ height: 15 }} />
          </Box>
        </Container>
      )
    );
  };

  const onFilterSubmit = () => {
    Log.info('Click button [Apply Filter] - Search Settlement Rejected list', filter);
    getSettlementList(setRejected, null, "rejected", false, filter);
  };

  // ------------------ end of filter stuffies --------------------//

  useEffect(() => {
    if (reset) setReset(false);
  }, [reset]);

  const getCSVData = async () => {
    const data = await getSettlementCSV(filter, "rejected");
    return data;
  };

  const getNext = async () => {
    if (!next) return;
    const res = await getNextPage({
      url: next,
      filter: filter,
    });
    let newRows = formatData(res);
    setTableData((old) => [...old, ...newRows]);
    setNext(res.next ? res.next : false);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  useEffect(() => {
    if (!loaded) {
      getSettlementFilterParams("rejected", setFParams);
      getSettlementList(setRejected, setLoaded, "rejected", false, filter);
    }
  }, [loaded]);

  const formatData = (input) => {
    let tableData = [];
    input.results.forEach(
      ({
        id,
        transaction,
        acquirer_request_amount,
        merchant,
        payment_brand,
        terminal,
        transaction_amount,
        transaction_currency,
        transaction_datetime,
        transaction_type,
        mdr_amount,
        paid_amount,
        transaction_fee,
      }) => {
        tableData.push({
          id: transaction,
          transaction_ID: transaction,
          terminal_ID: terminal && terminal.terminal_id,
          merchant: merchant && merchant.name,
          transaction_time:
            transaction_datetime && parseDateTime(transaction_datetime),
          MDR_amount: mdr_amount && mdr_amount,
          brand: payment_brand && payment_brand.name,
          currency: transaction_currency && transaction_currency,
          paid_amount: paid_amount && paid_amount,
          transaction_fee: parseCurrency(transaction_fee),
          transaction_amount:
            transaction_amount && parseCurrency(transaction_amount),
          type: transaction_type && transaction_type.transaction_type,
        });
      }
    );
    return tableData;
  };

  useEffect(() => {
    if (rejected) {
      setTableData(formatData(rejected));
      setNext(rejected.next);
    }
  }, [rejected]);

  return (
    <Container>
      <HeaderHelpPage title="Settlement Rejected" description="Rejected settlement needs Payout team to have a look to verify and transaction will not be included on the report" />

      {loaded ? (
        <Card>
          <ListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            date={fDate}
            filter={true}
            loaded={loaded}
            type="rejected_settlements"
            filterFunction={filterComponents}
            onFilterSubmit={onFilterSubmit}
            setReset={setReset}
            csv={false}
            getCSVData={rejected.count > 0 ? getCSVData : false}
          />
          <Scrollbar>
            <TableView
              rows={tableData}
              link={`/3/app/details/settlements~id~?status=rejected`}
              getNext={getNext}
              count={rejected.count}
              query={filterName}
            />
          </Scrollbar>
        </Card>
      ) : (
        <CircularLoader />
      )}
    </Container>
  );
}
